import { styled } from '@mui/material'

export const StyledForm = styled('form')(() => ({
  minWidth: '35rem',
  maxWidth: '35rem',
}))
